export default "__VITE_ASSET__BgLMV2yk__"